import React from 'react';
import {Box, Flex} from '@chakra-ui/react';

export const SectionContainer = ({children}: {children: React.ReactNode}) => {
  return (
    <Flex direction="column" gap="3">
      {children}
    </Flex>
  );
};

export const SectionTitle = ({children}: {children: React.ReactNode}) => {
  return <Box fontSize="md">{children}</Box>;
};
